import { useEffect, useState } from 'react';
import { InternalEventType } from '../../../clients/chat/types';

export default function useChatConnectionState() {
    const [connectedToChat, setConnectedToChat] = useState(false);
    useEffect(() => {
        const connectedToChatHandler = () => setConnectedToChat(true);
        const disconnectHandler = () => setConnectedToChat(false);

        window.addEventListener(InternalEventType.SUBSCRIBED_TO_CHAT, connectedToChatHandler);
        window.addEventListener(InternalEventType.CHAT_DISCONNECTED, disconnectHandler);
        return () => {
            window.removeEventListener(InternalEventType.CHAT_DISCONNECTED, disconnectHandler);
            window.removeEventListener(InternalEventType.SUBSCRIBED_TO_CHAT, connectedToChatHandler);
        };
    }, []);
    return { connectedToChat };
}
